/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui'
import { navigate } from 'gatsby'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Input, Box, Button } from '@theme-ui/components'
import { Search } from '@styled-icons/bootstrap/Search'

const SearchIcon = styled(Search)`
  width: 1em;
  pointer-events: none;
`

const SearchInputBox = ({ styles, searchURL, placeholder='Search' }) => {
  const [searchTerm, setSearchTerm] = useState('')

  const handleSubmit = e => {
    e.preventDefault()
    if (searchTerm !== '') {
      navigate(searchURL + searchTerm)
    }
  }

  const sx = {
    ...formStyle,
    ...styles,
  }

  return (
    <Box>
      <Box as="form" onSubmit={handleSubmit} sx={sx}>
        <StyledInput
          type="text"
          placeholder={placeholder}
          aria-label="Search"
          onChange={e => setSearchTerm(e.target.value)}
        />
        <Button onClick={handleSubmit}>
          <SearchIcon />
        </Button>
      </Box>
    </Box>
  )
}

const StyledInput = styled(Input)`
  margin: 0;
  padding: 8px;
  font-size: 1rem;
  :focus {
    -moz-box-shadow: inset 0 0 0px;
    -webkit-box-shadow: inset 0 0 0px;
    box-shadow: inset 0 0 0px;
  };
  bg: white;
`;

const formStyle = {
  my: 2,
  display: 'inline-flex',
  justifyContent: 'flex-start',
  border: '2px solid',
}

export default SearchInputBox
